$(function() {
  if (typeof Countries === "object" && typeof Countries_fr === "object") {
    for	(var key in Countries_fr) {
      if (Countries[key]) {
        Countries[key].country_label_fr = Countries_fr[key];
      }
    };
  }
});

if (typeof Countries === "object" && typeof Countries.Canada === "object") {
  Countries.Canada.province_labels_fr = {
    "Alberta": "Alberta",
    "British Columbia": "Colombie-Britannique",
    "Manitoba": "Manitoba",
    "New Brunswick": "Nouveau-Brunswick",
    "Newfoundland": "Terre-Neuve-et-Labrador",
    "Northwest Territories": "Territoires du Nord-Ouest",
    "Nova Scotia": "Nouvelle-Écosse",
    "Nunavut": "Nunavut",
    "Ontario": "Ontario",
    "Prince Edward Island": "Île-du-Prince-Édouard",
    "Quebec": "Québec",
    "Saskatchewan": "Saskatchewan",
    "Yukon": "Yukon"
  };
}

var Countries_fr = {
	"Canada" : "Canada",
	"Afghanistan" : "Afghanistan",
	"South Africa" : "Afrique du Sud",
	"Albania" : "Albanie",
	"Algeria" : "Algérie",
	"Germany" : "Allemagne",
	"Andorra" : "Andorre",
	"Angola" : "Angola",
	"Anguilla" : "Anguilla",
	"Antigua And Barbuda" : "Antigua-et-Barbuda",
	"Netherlands Antilles" : "Antilles néerlandaises",
	"Saudi Arabia" : "Arabie saoudite",
	"Argentina" : "Argentine",
	"Armenia" : "Arménie",
	"Aruba" : "Aruba",
	"Australia" : "Australie",
	"Austria" : "Autriche",
	"Azerbaijan" : "Azerbaïdjan",
	"Bahamas" : "Bahamas",
	"Bahrain" : "Bahreïn",
	"Bangladesh" : "Bangladesh",
	"Barbados" : "Barbade",
	"Belgium" : "Belgique",
	"Belize" : "Belize",
	"Benin" : "Bénin",
	"Bermuda" : "Bermudes",
	"Bhutan" : "Bhoutan",
	"Belarus" : "Biélorussie",
	"Bolivia" : "Bolivie",
	"Bosnia And Herzegovina" : "Bosnie-Herzégovine",
	"Botswana" : "Botswana",
	"Brazil" : "Brésil",
	"British Indian Ocean Territory" : "Territoire britannique de l’océan Indien",
	"Brunei" : "Brunéi Darussalam",
	"Bulgaria" : "Bulgarie",
	"Burkina Faso" : "Burkina Faso",
	"Burundi" : "Burundi",
	"Cambodia" : "Cambodge",
	"Republic of Cameroon" : "Cameroun",
	"Canada" : "Canada",
	"Cape Verde" : "Cap-Vert",
	"Chile" : "Chili",
	"China" : "Chine",
	"Cyprus" : "Chypre",
	"Colombia" : "Colombie",
	"Comoros" : "Comores",
	"Congo" : "Congo-Brazzaville",
	"Congo, The Democratic Republic Of The" : "Congo-Kinshasa",
	"Korea, Democratic People's Republic Of" : "Corée du Nord",
	"South Korea" : "Corée du Sud",
	"Costa Rica" : "Costa Rica",
	"Croatia" : "Croatie",
	"Cuba" : "Cuba",
	"Curaçao" : "Curaçao",
	"Côte d'Ivoire" : "Côte d’Ivoire",
	"Denmark" : "Danemark",
	"Djibouti" : "Djibouti",
	"Dominica" : "Dominique",
	"Egypt" : "Égypte",
	"El Salvador" : "El Salvador",
	"United Arab Emirates" : "Émirats arabes unis",
	"Ecuador" : "Équateur",
	"Eritrea" : "Érythrée",
	"Spain" : "Espagne",
	"Estonia" : "Estonie",
	"Holy See (Vatican City State)" : "État de la Cité du Vatican",
	"United States" : "États-Unis",
	"Ethiopia" : "Éthiopie",
	"Fiji" : "Fidji",
	"Finland" : "Finlande",
	"France" : "France",
	"Gabon" : "Gabon",
	"Gambia" : "Gambie",
	"Georgia" : "Géorgie",
	"Ghana" : "Ghana",
	"Gibraltar" : "Gibraltar",
	"Greece" : "Grèce",
	"Grenada" : "Grenade",
	"Greenland" : "Groenland",
	"Guadeloupe" : "Guadeloupe",
	"Guatemala" : "Guatemala",
	"Guernsey" : "Guernesey",
	"Guinea" : "Guinée",
	"Equatorial Guinea" : "Guinée équatoriale",
	"Guinea Bissau" : "Guinée-Bissau",
	"Guyana" : "Guyana",
	"French Guiana" : "Guyane française",
	"Haiti" : "Haïti",
	"Honduras" : "Honduras",
	"Hungary" : "Hongrie",
	"Bouvet Island" : "Île Bouvet",
	"Christmas Island" : "Île Christmas",
	"Norfolk Island" : "Île Norfolk",
	"Isle Of Man" : "Île de Man",
	"Aland Islands" : "Îles Åland",
	"Cayman Islands" : "Îles Caïmans",
	"Cocos (Keeling) Islands" : "Îles Cocos",
	"Cook Islands" : "Îles Cook",
	"Faroe Islands" : "Îles Féroé",
	"South Georgia And The South Sandwich Islands" : "Îles Géorgie du Sud et Sandwich du Sud",
	"Heard Island And Mcdonald Islands" : "Îles Heard et McDonald",
	"Falkland Islands (Malvinas)" : "Îles Malouines",
	"Solomon Islands" : "Îles Salomon",
	"Turks and Caicos Islands" : "Îles Turques-et-Caïques",
	"Virgin Islands, British" : "Îles Vierges britanniques",
	"United States Minor Outlying Islands" : "Îles mineures éloignées des États-Unis",
	"India" : "Inde",
	"Indonesia" : "Indonésie",
	"Iraq" : "Irak",
	"Iran, Islamic Republic Of" : "Iran",
	"Ireland" : "Irlande",
	"Iceland" : "Islande",
	"Israel" : "Israël",
	"Italy" : "Italie",
	"Jamaica" : "Jamaïque",
	"Japan" : "Japon",
	"Jersey" : "Jersey",
	"Jordan" : "Jordanie",
	"Kazakhstan" : "Kazakhstan",
	"Kenya" : "Kenya",
	"Kyrgyzstan" : "Kirghizistan",
	"Kiribati" : "Kiribati",
	"Kosovo" : "Kosovo",
	"Kuwait" : "Koweït",
	"Reunion" : "La Réunion",
	"Lao People's Democratic Republic" : "Laos",
	"Lesotho" : "Lesotho",
	"Latvia" : "Lettonie",
	"Lebanon" : "Liban",
	"Liberia" : "Libéria",
	"Libyan Arab Jamahiriya" : "Libye",
	"Liechtenstein" : "Liechtenstein",
	"Lithuania" : "Lituanie",
	"Luxembourg" : "Luxembourg",
	"Macedonia, Republic Of" : "Macédoine",
	"Madagascar" : "Madagascar",
	"Malaysia" : "Malaisie",
	"Malawi" : "Malawi",
	"Maldives" : "Maldives",
	"Mali" : "Mali",
	"Malta" : "Malte",
	"Morocco" : "Maroc",
	"Martinique" : "Martinique",
	"Mauritius" : "Maurice",
	"Mauritania" : "Mauritanie",
	"Mayotte" : "Mayotte",
	"Mexico" : "Mexique",
	"Moldova, Republic of" : "Moldavie",
	"Monaco" : "Monaco",
	"Mongolia" : "Mongolie",
	"Montenegro" : "Monténégro",
	"Montserrat" : "Montserrat",
	"Mozambique" : "Mozambique",
	"Myanmar" : "Myanmar",
	"Namibia" : "Namibie",
	"Nauru" : "Nauru",
	"Nepal" : "Népal",
	"Nicaragua" : "Nicaragua",
	"Niger" : "Niger",
	"Nigeria" : "Nigéria",
	"Niue" : "Niue",
	"Norway" : "Norvège",
	"New Caledonia" : "Nouvelle-Calédonie",
	"New Zealand" : "Nouvelle-Zélande",
	"Oman" : "Oman",
	"Uganda" : "Ouganda",
	"Uzbekistan" : "Ouzbékistan",
	"Pakistan" : "Pakistan",
	"Panama" : "Panama",
	"Papua New Guinea" : "Papouasie-Nouvelle-Guinée",
	"Paraguay" : "Paraguay",
	"Netherlands" : "Pays-Bas",
	"Peru" : "Pérou",
	"Philippines" : "Philippines",
	"Pitcairn" : "Pitcairn",
	"Poland" : "Pologne",
	"French Polynesia" : "Polynésie française",
	"Portugal" : "Portugal",
	"Qatar" : "Qatar",
	"Hong Kong" : "R.A.S. chinoise de Hong Kong",
	"Macao" : "R.A.S. chinoise de Macao",
	"Central African Republic" : "République centrafricaine",
	"Dominican Republic" : "République dominicaine",
	"Czech Republic" : "République tchèque",
	"Romania" : "Roumanie",
	"United Kingdom" : "Royaume-Uni",
	"Russia" : "Russie",
	"Rwanda" : "Rwanda",
	"Western Sahara" : "Sahara occidental",
	"Saint Barthélemy" : "Saint-Barthélemy",
	"Saint Kitts And Nevis" : "Saint-Christophe-et-Niévès",
	"San Marino" : "Saint-Marin",
	"Saint Martin" : "Saint-Martin (partie française)",
	"Sint Maarten" : "Saint-Martin (partie néerlandaise)",
	"Saint Pierre And Miquelon" : "Saint-Pierre-et-Miquelon",
	"St. Vincent" : "Saint-Vincent-et-les-Grenadines",
	"Saint Helena" : "Sainte-Hélène",
	"Saint Lucia" : "Sainte-Lucie",
	"Samoa" : "Samoa",
	"Sao Tome And Principe" : "Sao Tomé-et-Principe",
	"Senegal" : "Sénégal",
	"Serbia" : "Serbie",
	"Seychelles" : "Seychelles",
	"Sierra Leone" : "Sierra Leone",
	"Singapore" : "Singapour",
	"Slovakia" : "Slovaquie",
	"Slovenia" : "Slovénie",
	"Somalia" : "Somalie",
	"Sudan" : "Soudan",
	"South Sudan" : "Soudan du Sud",
	"Sri Lanka" : "Sri Lanka",
	"Sweden" : "Suède",
	"Switzerland" : "Suisse",
	"Suriname" : "Suriname",
	"Svalbard And Jan Mayen" : "Svalbard et Jan Mayen",
	"Swaziland" : "Swaziland",
	"Syria" : "Syrie",
	"Tajikistan" : "Tadjikistan",
	"Taiwan" : "Taïwan",
	"Tanzania, United Republic Of" : "Tanzanie",
	"Chad" : "Tchad",
	"French Southern Territories" : "Terres australes françaises",
	"Palestinian Territory, Occupied" : "Territoires palestiniens",
	"Thailand" : "Thaïlande",
	"Timor Leste" : "Timor oriental",
	"Togo" : "Togo",
	"Tokelau" : "Tokelau",
	"Tonga" : "Tonga",
	"Trinidad and Tobago" : "Trinité-et-Tobago",
	"Tunisia" : "Tunisie",
	"Turkmenistan" : "Turkménistan",
	"Turkey" : "Turquie",
	"Tuvalu" : "Tuvalu",
	"Ukraine" : "Ukraine",
	"Uruguay" : "Uruguay",
	"Vanuatu" : "Vanuatu",
	"Venezuela" : "Venezuela",
	"Vietnam" : "Vietnam",
	"Wallis And Futuna" : "Wallis-et-Futuna",
	"Yemen" : "Yémen",
	"Zambia" : "Zambie",
	"Zimbabwe" : "Zimbabwe"
 };
